// dependencies
import { NavigationTypes, STORAGE_TYPES } from "@swiggy-private/native-bridge";

// helpers
import { getBridgeSdk } from "@checkout-core/utils";

// Opens feedback webview using the given link
export const navigateToDeeplink = (link: string) => {
    getBridgeSdk()
        .navigateToScreen({
            type: NavigationTypes.DEEPLINK,
            link,
        })
        ?.catch(() => void 0);
};

// Check whether feedback has been shown for a given key
export const canShowFeedbackScreen = async (key: string): Promise<boolean> => {
    try {
        const response = await getBridgeSdk().storage({
            type: STORAGE_TYPES.GET,
            data: {
                [key]: "",
            },
        });

        const feedbackShownTime = response?.data[key];
        // if the flag is absent, user has not seen the feedback screen ever
        if (feedbackShownTime == null) {
            return true;
        }

        // checking if feedback is shown once in last 30 days
        const dateOffset = 24 * 60 * 60 * 1000 * 30; // 30 days
        if (Date.now() - Number(feedbackShownTime) > dateOffset) {
            // deletes the flag
            getBridgeSdk().storage({
                type: STORAGE_TYPES.DELETE,
                data: {
                    [key]: "",
                },
            });

            return true;
        }

        return false;
    } catch (_) {
        return false;
    }
};

// Updates the feedback flag for a given key
export const updateFeedbackFlag = async (key: string): Promise<string> => {
    const currentTimestamp = String(Date.now());

    await getBridgeSdk().storage({
        type: STORAGE_TYPES.SAVE,
        data: {
            [key]: currentTimestamp,
        },
    });
    return currentTimestamp;
};
